import {Component, Input} from "@angular/core";
import {ProductModel} from "../../../models/product/product.model";

@Component({
  selector: "pcg-ng-register-interest-message",
  template: require('./register-interest-message.component.html')
})
export class RegisterInterestMessageComponent {
    private FORM_URL: string = "/registerinterest/form";

    @Input()
    public product: ProductModel;

    public generateUrl(): string {
        const params = {
            collectionName: this.product.collectionName,
            catalogueNumber: this.product.catalogueNumber,
            productName: this.product.name,
            productUrl: this.product.url
        };

        const queryParams = Object.keys(params)
            .map(key => `${key}=${params[key]}`)
            .join("&");

        const url = `${this.FORM_URL}?${queryParams}`;

        return url;
    }
}
